import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { LangProvider } from "@/i18n";
import { StoreProvider } from "@/contexts/StoreContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import TrustStrip from "@/components/TrustStrip";
import CartDrawer from "@/components/CartDrawer";
import ObiChatWidget from "@/components/ObiChatWidget";
import CookieBanner from "@/components/CookieBanner";
import { trackPageView } from "@/lib/analytics";

import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CheckoutPage from "@/pages/CheckoutPage";
import WishlistPage from "@/pages/WishlistPage";
import AboutPage from "@/pages/AboutPage";
import GiftFinderPage from "@/pages/GiftFinderPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiePage from "@/pages/CookiePage";
import ShippingPage from "@/pages/ShippingPage";
import NotFoundPage from "@/pages/NotFoundPage";

const RouteTracker = () => {
  const location = useLocation();
  React.useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-amber-50">
      <LangProvider>
        <StoreProvider>
          <BrowserRouter>
            <RouteTracker />
            <Header />
            <CartDrawer />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/catalog" element={<CatalogPage />} />
                <Route path="/product/:id" element={<ProductDetailPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/chi-siamo" element={<AboutPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/regalo-perfetto" element={<GiftFinderPage />} />
                <Route path="/gift-finder" element={<GiftFinderPage />} />
                <Route path="/termini-e-condizioni" element={<TermsPage />} />
                <Route path="/privacy-policy" element={<PrivacyPage />} />
                <Route path="/cookie-policy" element={<CookiePage />} />
                <Route path="/spedizioni-e-resi" element={<ShippingPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <TrustStrip />
            <Footer />
            <ObiChatWidget />
            <CookieBanner />
          </BrowserRouter>
        </StoreProvider>
      </LangProvider>
    </div>
  );
}

export default App;
